import {BASE_SERVICE_URL} from '../lib/constants'

export default function getModels() {
    return fetch(BASE_SERVICE_URL + `/models`, {
        credentials: 'same-origin',
    }).then((response) => {
        if (response.ok) {
            return response.json();
        } else {
            var error = new Error(response.statusText);
            error.response = response;
            throw error;
        }
    });
}
